import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigService, ResourceService } from 'common';
import { ApplicationEnvelopeData } from './signing-widget.model';

@Injectable({
  providedIn: 'root'
})
export class DocuSignEnvelopeService {
  private get baseUrl(): string {
    return `${this.configService.environment.customersAPI.url}/docusign`;
  }

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
    private readonly resourceService: ResourceService,
  ) { }

  /** The application's current envelope, or null when it has none. */
  getByApplication(applicationId: number): Observable<ApplicationEnvelopeData> {
    return this.getOrNull(`${this.baseUrl}/envelopes/${applicationId}`);
  }

  /** The current envelope of the application that opened the loan, or null when it has none. */
  getByLoan(loanId: number): Observable<ApplicationEnvelopeData> {
    return this.getOrNull(`${this.baseUrl}/loans/${loanId}/envelope`);
  }

  downloadCertificate(envelopeId: number): void {
    this.resourceService.download({ url: `${this.baseUrl}/envelopes/${envelopeId}/certificate` }).subscribe();
  }

  private getOrNull(url: string): Observable<ApplicationEnvelopeData> {
    return this.http.get<ApplicationEnvelopeData>(url, { headers: this.configService.environment.cache.noCache })
      .pipe(catchError((error: HttpErrorResponse) => error.status === 404 ? of(null) : throwError(() => error)));
  }
}
